import * as types from '@/store/modules/parametres-mutation-type';

export const LIST_PARAMETER_WITH_SOCIETE_ID = [
  types.PARAMETRES_KEYS.domiciliationBancaire,
  types.PARAMETRES_KEYS.exercice,
  types.PARAMETRES_KEYS.typeTaxationTlpe,
  types.PARAMETRES_KEYS.parametrageEdition,
  types.PARAMETRES_KEYS.regimeTva,
  types.PARAMETRES_KEYS.compteAnalytique,
  types.PARAMETRES_KEYS.typeOt,
  types.PARAMETRES_KEYS.formatAffiche,
];

export const LIST_SORTING_EXCEPTION = [
  { type: types.PARAMETRES_KEYS.exercice, tri: 'code ASC' },
  { type: types.PARAMETRES_KEYS.parametrageEdition, tri: 'typeEdition ASC' },
  { type: types.PARAMETRES_KEYS.regimeTva, tri: 'TauxTva DESC' },
  { type: types.PARAMETRES_KEYS.compteAnalytique, tri: 'compteAnalytique ASC' },
  { type: types.PARAMETRES_KEYS.pays, tri: 'nom ASC' },
];
